"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _Toggler = require("b2b-components/core/components/Dropdown/Toggler");
var _Dropdown = require("b2b-components/theme/components/Dropdown");
var _Icon = require("b2b-components/theme/components/Icon");
var _device = require("b2b-components/utils/device");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("../");
require("./Dropdown.scss");
const Dropdown = _ref => {
  let {
    label,
    groups,
    onLinkClick,
    deviceType,
    className
  } = _ref;
  const isMobileDevice = (0, _device.isMobile)(deviceType);
  const rootClassName = (0, _classnames.default)('cds-AccountMenu-Dropdown', {
    'cds-AccountMenu-Dropdown--Mobile': isMobileDevice
  }, className);
  const activeLink = groups.reduce((allItems, group) => [...allItems, ...group.items], []).find(item => 'isActive' in item && item.isActive);
  return /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
    className: rootClassName,
    hasTogglerWidth: true,
    content: /*#__PURE__*/_react.default.createElement(_.AccountMenu, {
      groups: groups,
      onLinkClick: onLinkClick
    }),
    togglerProps: {
      label: isMobileDevice && activeLink ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, 'icon' in activeLink && activeLink.icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        name: activeLink.icon,
        size: _Icon.ICON_SIZE.small,
        className: "cds-AccountMenu-ItemIcon"
      }), activeLink.title) : label,
      styleType: _Toggler.DROPDOWN_TOGGLER_STYLE_TYPE.button,
      className: 'cds-AccountMenu-DropdownButton'
    }
  });
};
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map